import request from "@/utils/request";

//附件上传
export function appendFileUpload(data) {
  return request({
    url: "/upload/appendFileUpload",
    method: "post",
    data,
  });
}

//获取产业类别列表
export function listIndustryCategory(data) {
  return request({
    url: "/policy/listIndustryCategory",
    method: "get",
    data,
  });
}

//获取项目类型列表
export function listItemCategory(data) {
  return request({
    url: "/policy/listItemCategory",
    method: "get",
    data,
  });
}

//政策发布列表
export function listPolicyPublish(data) {
  return request({
    url: "/policy/listPolicyPublic",
    method: "post",
    data,
  });
}

//添加政策
export function policyCreate(data) {
  return request({
    url: "/policy/PolicyCreate",
    method: "post",
    data,
  });
}

//删除政策
export function delPolicyPublic(data) {
  return request({
    url: "/policy/delPolicyPublic",
    method: "post",
    data,
  });
}

//根据id查政策
export function findPolicy(id) {
  return request({
    url: "/policy/findPolicyById/"+id,
    method: "get",
  });
}

//发布政策
export function publishPolicy(data) {
  return request({
    url: "/policy/publishPolicy",
    method: "post",
    data,
  });
}